import styles from "./day.module.css";
import { useState, useEffect } from "react";
import { AiFillDelete } from "react-icons/ai";
import { AiOutlinePlus } from "react-icons/ai";
import { FaRegSnowflake } from "react-icons/fa";
import { FaCloudRain } from "react-icons/fa";
import { IoSunnySharp } from "react-icons/io5";
import Modal from "./Modal";
import MealList from "./MealList";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import { getCities } from "../APIFunctions";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "../../create-tours/mainPage/mainPage.css";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import CreatableSelect from "react-select/creatable";
import { translateToReactSelect } from "admin-panel/create-tours/helperFunctions";

const Day = ({
  day,
  deleteHandler,
  index,
  allMealsHandler,
  name,
  catValue,
  vehValue,
  changeHandlerVehicle,
  isKhareji,
  isLastDay,
}) => {
  const meals = useMeals();
  const dispatch = useMealsAction();
  const [radio, setRadio] = useState("");
  const [allCities, setAllCities] = useState([]);

  const addMealsHandler = () =>
    dispatch({ type: "addMealsHandler", id: meals.id });
  useEffect(() => {}, [meals[0][12].name]);

  useEffect(() => {
    const getInfo = async (e) => {
      let data = await getCities().then((res) => res);

      let allCities = [];
      for (let index = 0; index < data.length; index++) {
        let newObject = {};
        newObject.value = data[index].id;
        newObject.label = data[index].title;
        allCities.push(newObject);
      }

      setAllCities(allCities);
    };
    getInfo();
  }, []);
  useEffect(() => {
    allMealsHandler(meals, index);
  }, [meals]);

  const renderdays = () => {
    if (index === 0) {
      return (
        <div className={styles.indexBox}>
          <div className={`order-lg-6  ${styles.flewRowDay1}`}>
            <p className={styles.detailp}>روز و زمان حرکت</p>
            <DatePicker
              className={`rmdp-prime  dateBox2`}
              style={{
                background: "white",
                border: "1px rgb(219, 219, 219) solid",
              }}
              value={meals[0][10].datepick}
              onChange={(value) =>
                dispatch({
                  type: "changeDate",

                  id: 10,
                  value: value.valueOf(),
                })
              }
              format="YYYY/MM/DD HH:mm:ss"
              plugins={[<TimePicker position="left" dir="ltr" />]}
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
            />
          </div>

          <div className={`order-lg-8  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>محل حرکت</p>
            <input
              type="text"
              className={styles.inputBoxs}
              value={meals[index][11].name}
              onChange={(e) =>
                dispatch({
                  type: "changer",

                  id: 11,
                  event: e,
                })
              }
            />
          </div>
          <div className={`order-lg-9  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>شهر مبدا </p>
            <div style={{ margin: "3px", width: "50%" }}>
              <CreatableSelect
                name="startingCity"
                closeMenuOnSelect={true}
                isMulti={false}
                options={allCities}
                value={translateToReactSelect([meals[0][12].name], false)}
                onChange={(e) => {
                  if (!allCities.some((value) => value.value == e.value)) {
                    e.value = -1;
                  }
                  dispatch({
                    type: "changer",

                    id: 12,
                    event: e,
                  });
                }}
              />
            </div>
          </div>
          <div className={`order-lg-10  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>ظرفیت کامل تور</p>
            <input
              type="text"
              className={styles.inputBoxs}
              value={addCommas(meals[0][13].name)}
              onChange={(e) =>
                dispatch({
                  type: "changer",

                  id: 13,
                  event: e,
                })
              }
            />
          </div>
          <div className={`order-lg-5  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>ظرفیت نمایشی</p>

            <input
              type="text"
              className={styles.inputBoxs}
              value={addCommas(meals[0][14].name)}
              onChange={(e) =>
                dispatch({
                  type: "changer",

                  id: 14,
                  event: e,
                })
              }
            />
            {parseInt(meals[0][14].name) > parseInt(meals[0][13].name) && (
              <p className={styles.tedadi}>از ظرفیت کامل بیشتر نباشد</p>
            )}
          </div>
          <div className={`order-lg-4  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>مبلغ بیمه</p>
            <input
              type="text"
              className={styles.inputBoxs}
              value={addCommas(meals[index][15].price)}
              onChange={(e) =>
                dispatch({
                  type: "changing",

                  id: 15,
                  event: e,
                })
              }
            />
          </div>
          <div className={`order-lg-3  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>نام ترنسفر اصلی</p>
            <select
              class="form-select form-select-sm"
              aria-label=".form-select-sm example"
              className={styles.inputBoxs}
              value={meals[index][19].trans}
              onChange={(e) =>
                dispatch({
                  type: "changeHandlerTrans",

                  id: 19,
                  event: e,
                })
              }
            >
              <option
                selected
                hidden
                disabled
                className={styles.selected}
              ></option>
              <option value="ghatar" className={styles.optionValue}>
                قطار
              </option>
              <option value="airplan" className={styles.optionValue}>
                هواپیما
              </option>
              <option value="bus" className={styles.optionValue}>
                اتوبوس 44 نفره
              </option>
              <option value="bus2" className={styles.optionValue}>
                {" "}
                اتوبوس 25 نفره
              </option>
              <option value="van" className={styles.optionValue}>
                ون
              </option>
              <option value="miniBus" className={styles.optionValue}>
                مینی بوس
              </option>
              <option value="keshti" className={styles.optionValue}>
                {" "}
                کشتی
              </option>
            </select>
          </div>
          <div className={`order-lg-2  ${styles.flewRowDay}`}>
            <p className={styles.detailp}>نوع ترنسفر اصلی</p>
            <select
              class="form-select form-select-sm"
              aria-label=".form-select-sm example"
              className={styles.inputBoxs}
              value={meals[index][16].trans}
              onChange={(e) =>
                dispatch({
                  type: "changeHandlerTrans",

                  id: 16,
                  event: e,
                })
              }
            >
              <option
                selected
                hidden
                disabled
                className={styles.selected}
              ></option>
              <option value="omumi" className={styles.optionValue}>
                نفری
              </option>
              <option value="darbasti" className={styles.optionValue}>
                گروهی
              </option>
            </select>
          </div>
          <div className={`order-lg-1 ${styles.flewRowDay}`}>
            <p className={styles.detailp}>قیمت ترنسفر</p>
            <input
              type="text"
              className={styles.inputBoxs}
              value={addCommas(meals[0][17].price)}
              onChange={(e) =>
                dispatch({
                  type: "changing",

                  id: 17,
                  event: e,
                })
              }
            />
          </div>
          {isKhareji && (
            <div className={`order-lg-0  ${styles.flewRowDay}`}>
              <p className={styles.detailp}>مبلغ سیم کارت</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[index][18].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changing",

                    id: 18,
                    event: e,
                  })
                }
              />
            </div>
          )}
        </div>
      );
    }
  };
  const renderbtn = () => {
    if (index === 0) {
      return <div></div>;
    }
  };
  return (
    <div className={`${styles.dayBox} ${index === 0 && styles.dayBox2}`}>
      <p className={styles.headTitle}>{name}</p>

      {renderdays()}
      <MealList
        meals={meals}
        dayIndex={index}
        vehValue={vehValue}
        changeHandlerVehicle={changeHandlerVehicle}
      />

      <div className={`mt-2 ${styles.flewRowCost}`}>
        <p class="m-auto p-2">آب و هوا</p>
        <div className={`d-flex  ${styles.mainRad}`}>
          <div>
            <input
              id={`sunny-${index}`}
              className={`d-none ${styles.weatherInput}`}
              type="radio"
              checked={meals[index][9].weather === "sun"}
              value="sun"
              onChange={(e) =>
                dispatch({
                  type: "changeHandlerWeather",
                  day: index,
                  id: 9,
                  event: e,
                })
              }
            />
            <label htmlFor={`sunny-${index}`} className={styles.weatherLabel}>
              <IoSunnySharp className={styles.iconSw} />
            </label>
          </div>
          <div>
            {" "}
            <input
              id={`rainy-${index}`}
              className={`d-none ${styles.weatherInput}`}
              type="radio"
              checked={meals[index][9].weather === "rain"}
              value="rain"
              onChange={(e) =>
                dispatch({
                  type: "changeHandlerWeather",
                  day: index,
                  id: 9,
                  event: e,
                })
              }
            />
            <label htmlFor={`rainy-${index}`} className={styles.weatherLabel}>
              <FaCloudRain className={styles.iconSw} />
            </label>
          </div>
          <div>
            {" "}
            <input
              id={`snowy-${index}`}
              className={`d-none ${styles.weatherInput}`}
              type="radio"
              checked={meals[index][9].weather === "snow"}
              value="snow"
              onChange={(e) =>
                dispatch({
                  type: "changeHandlerWeather",
                  day: index,
                  id: 9,
                  event: e,
                })
              }
            />
            <label htmlFor={`snowy-${index}`} className={styles.weatherLabel}>
              <FaRegSnowflake className={styles.iconSw} />
            </label>
          </div>
        </div>
      </div>
      <div className={styles.btns}>
        {!renderbtn() ? (
          <div>
            <button
              type="button"
              className={styles.modalBtn}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal-${index}`}
            >
              <AiOutlinePlus />
            </button>
            {isLastDay && (
              <button className={styles.deleteBtn} onClick={deleteHandler}>
                <AiFillDelete />
              </button>
            )}
          </div>
        ) : (
          <div>
            <button
              type="button"
              className={styles.modalBtn}
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal-${index}`}
            >
              <AiOutlinePlus />
            </button>
          </div>
        )}
      </div>

      <Modal addMealsHandler={addMealsHandler} index={index} />
    </div>
  );
};

export default Day;

const numbersOne = [1, 2, 3];
const numbersCombined = [...numbersOne];
